import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { useDispatchOnMount } from '../../../hooks';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import { selectOptionFactory } from '../../../utils';
import FilterCardMultiSelect from '../../generic/Filter/FilterCardMultiSelect';

type Props = { cwes: string[]; setFilters: (...args: any[]) => void };

/**
 * Renders an autocomplete CWEs dropdown
 */
const VulnCWE: VoidFunctionComponent<Props> = ({
  cwes,
  setFilters,
}) => {
  useDispatchOnMount(PackageInventoryStore.actions.fetchCwes);
  const options = useSelector(PackageInventoryStore.selectors.getCwesOptions);
  const { isLoading } = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetCwes);

  return (
    <FilterCardMultiSelect
      isDisabled={isLoading}
      label="CWE"
      options={options}
      placeholder="Select one or more..."
      values={cwes.map((cwe) => selectOptionFactory(cwe))}
      onChange={(selectedOptions) => {
        if (selectedOptions.length) {
          setFilters({
            cwes: selectedOptions.map((option) => option.value),
          });
        } else {
          setFilters({
            cwes: [],
          });
        }
      }}
    />
  );
};

export default VulnCWE;
